import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { DefaultButton, FontIcon } from '@bingads-webui-react/fluent-controls';
import { registerIcons } from '@fluentui/style-utilities';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getTextAssetRecommendationsDropdownStyles } from './styles';
import copilot from '../media/copilot.svg';

registerIcons({
  icons: {
    copilot: (<img src={copilot} alt="copilot" />),
  },
});

const TextAssetRecommendationsDropdownUnstyled = ({
  classes,
  assetKey,
  applyRecommendation,
  recommendations,
  i18n,
  DKIThemeName,
}) => (
  <ul className={classnames('text-asset-recommendation-list', classes.TextAssetRecommendationsDropdown)} role="menu">
    {
      recommendations.map(({ name, assets }) => (
        <>
          <FontIcon className="text-asset-recommendation-theme-icon" iconName="copilot" />
          <li className="text-asset-recommendation-theme-title" role="presentation">
            {name === DKIThemeName ? i18n.getString(DKIThemeName) : name}
          </li>
          {
            assets.map(asset => (
              <li className="text-asset-recommendation-asset" role="menuitem">
                <DefaultButton onClick={() => applyRecommendation(assetKey, asset)}>
                  {asset}
                </DefaultButton>
              </li>
            ))
          }
        </>
      ))
    }
  </ul>
);

TextAssetRecommendationsDropdownUnstyled.propTypes = {
  classes: PropTypes.shape({
    TextAssetRecommendationsDropdown: PropTypes.string,
  }).isRequired,
  assetKey: PropTypes.string.isRequired,
  applyRecommendation: PropTypes.func.isRequired,
  recommendations: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    assets: PropTypes.arrayOf(PropTypes.string),
  })).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  DKIThemeName: PropTypes.string,
};

TextAssetRecommendationsDropdownUnstyled.defaultProps = {
  DKIThemeName: '',
};

export const TextAssetRecommendationsDropdown = withDefaultStyles(TextAssetRecommendationsDropdownUnstyled, getTextAssetRecommendationsDropdownStyles);
